import { styled } from 'styled-components';

export const EnhanceDialogWrapper = styled('div')({
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '16px 24px 24px 24px',
  boxSizing: 'border-box',
  backgroundColor: '#F8F9FA'
});

export const EnhanceContentWrapper = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  overflow: 'hidden',
  flexGrow: 1
});
